const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

customElements.define('custom-main-login', class extends HTMLElement {
  constructor() {
    super();
    this.querySelector('#ContactForm-checkbox4').addEventListener('change', (e) => {
      localStorage.setItem('emailYN', e.target.checked ? 'Y' : 'N');
    })

    // Helper function to toggle all temp buttons
    const toggleTempButtons = (hide) => {
      const tempButtons = this.querySelectorAll('.temp_button');
      tempButtons.forEach(btn => {
        if (hide) {
          btn.classList.add('hide_temp_button');
        } else {
          btn.classList.remove('hide_temp_button');
        }
      });
    };

    this.querySelector('#ContactForm-checkbox1').addEventListener('change', (e) => {
      const checkbox2 = this.querySelector('#ContactForm-checkbox2');
      const agreementError = this.querySelector('#agreement').querySelector('.form-field__text--error');

      if (e.target.checked) {
        agreementError.classList.add('hidden');

        if (checkbox2.checked) {
          toggleTempButtons(true);
        } else {
          toggleTempButtons(false);
        }
      } else {
        toggleTempButtons(false);
        agreementError.classList.remove('hidden');
      }
    })

    this.querySelector('#ContactForm-checkbox2').addEventListener('change', (e) => {
      const checkbox1 = this.querySelector('#ContactForm-checkbox1');
      const privacyError = this.querySelector('#privacy').querySelector('.form-field__text--error');

      if (e.target.checked) {
        privacyError.classList.add('hidden');

        if (checkbox1.checked) {
          toggleTempButtons(true);
        } else {
          toggleTempButtons(false);
        }
      } else {
        toggleTempButtons(false);
        privacyError.classList.remove('hidden');
      }
    })

    this.querySelector('#reset').addEventListener('click', (e) => {
      const resetPasswordWrapper = this.querySelector('.recover');
      const email = resetPasswordWrapper.querySelector('#RecoverEmail');
      const errorMsg = resetPasswordWrapper.querySelector('.form-field__text--error');
      
      if (!EMAIL_REGEX.test(email.value)) {
        errorMsg.classList.remove('hidden');
      } else {
        errorMsg.classList.add('hidden');
        const form = resetPasswordWrapper.querySelector('form');
        form.submit();
      }
    })

    this.handleCheckInitEmail();
    this.handleAddFakeBtns();
  }

  handleCheckInitEmail() {
    const localEmailYN = localStorage.getItem('emailYN');
    if (!localEmailYN) {
      localStorage.setItem('emailYN', 'N');
    }
  }

  handleAddFakeBtns() {
    const snsLoginBtns = this.querySelector('.h_buttons');
    if (!snsLoginBtns) {
      // Wait for container to appear using MutationObserver
      const containerObserver = new MutationObserver((mutations, obs) => {
        const container = this.querySelector('.h_buttons');
        if (container) {
          obs.disconnect();
          this.initTempButtons(container);
        }
      });
      containerObserver.observe(this, { childList: true, subtree: true });
      return;
    }
    
    this.initTempButtons(snsLoginBtns);
  }

  initTempButtons(snsLoginBtns) {
    // Check if already initialized
    if (snsLoginBtns.dataset.tempButtonsInitialized === 'true') {
      return;
    }
    snsLoginBtns.dataset.tempButtonsInitialized = 'true';

    const tempButtons = new Map(); // realBtn -> tempBtn mapping
    let rafId = null;

    // Update button positions (optimized with requestAnimationFrame)
    const updateButtonPositions = () => {
      if (rafId) cancelAnimationFrame(rafId);
      
      rafId = requestAnimationFrame(() => {
        const containerRect = snsLoginBtns.getBoundingClientRect();
        
        tempButtons.forEach((tempBtn, realBtn) => {
          if (!realBtn.isConnected || !tempBtn.isConnected) {
            tempButtons.delete(realBtn);
            tempBtn.remove();
            return;
          }

          const rect = realBtn.getBoundingClientRect();
          tempBtn.style.top = `${rect.top - containerRect.top + snsLoginBtns.scrollTop}px`;
          tempBtn.style.left = `${rect.left - containerRect.left}px`;
          tempBtn.style.width = `${rect.width}px`;
          tempBtn.style.height = `${rect.height}px`;
        });
      });
    };

    // Create temp button for real button
    const createTempButton = (realBtn) => {
      if (tempButtons.has(realBtn)) return;

      const tempBtn = document.createElement('div');
      tempBtn.className = `${realBtn.className} temp_button`;
      tempBtn.innerHTML = realBtn.innerHTML;
      tempBtn.setAttribute('aria-hidden', 'true');
      tempBtn.setAttribute('tabindex', '-1');
      
      snsLoginBtns.appendChild(tempBtn);
      tempButtons.set(realBtn, tempBtn);
      updateButtonPositions();
    };

    // Process initial buttons
    const realButtons = Array.from(snsLoginBtns.children).filter(btn => 
      !btn.classList.contains('temp_button')
    );
    realButtons.forEach(createTempButton);

    // Event delegation: handle temp button clicks
    snsLoginBtns.addEventListener('click', (e) => {
      const tempBtn = e.target.closest('.temp_button');
      if (!tempBtn || tempBtn.classList.contains('hide_temp_button')) return;

      e.preventDefault();
      e.stopPropagation();
      
      location.href = "#ContactForm-checkbox1";

      const checkbox1 = this.querySelector('#ContactForm-checkbox1');
      const checkbox2 = this.querySelector('#ContactForm-checkbox2');

      if (!checkbox1?.checked) {
        const agreementError = this.querySelector('#agreement')?.querySelector('.form-field__text--error');
        agreementError?.classList.remove('hidden');
      }

      if (!checkbox2?.checked) {
        const privacyError = this.querySelector('#privacy')?.querySelector('.form-field__text--error');
        privacyError?.classList.remove('hidden');
      }
    });

    // MutationObserver: detect button additions/removals
    const buttonObserver = new MutationObserver((mutations) => {
      let needsUpdate = false;

      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1 && !node.classList.contains('temp_button')) {
            createTempButton(node);
            needsUpdate = true;
          }
        });

        mutation.removedNodes.forEach(node => {
          if (node.nodeType === 1 && tempButtons.has(node)) {
            tempButtons.get(node)?.remove();
            tempButtons.delete(node);
            needsUpdate = true;
          }
        });
      });

      if (needsUpdate) {
        updateButtonPositions();
      }
    });

    buttonObserver.observe(snsLoginBtns, {
      childList: true,
      subtree: false
    });

    // Resize and scroll events (throttled)
    let resizeTimeout;
    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(updateButtonPositions, 16);
    };

    window.addEventListener('resize', handleResize, { passive: true });
    snsLoginBtns.addEventListener('scroll', updateButtonPositions, { passive: true });

    // Set initial positions
    updateButtonPositions();
  }
})
